import React, { useCallback, useState } from 'react';
import MenuIcon from './MenuIcon'
import MenuModal from './MenuModal'
import BleedoutTimer from './BleedoutTimer'
import GeneralButton, { IGeneralButton } from './GeneralButton';
import { isPropertySignature } from 'typescript';
import { updateElementFocus } from '../../../misc/helpers';

const PauseMenu = (props: any) => {
	const modalButtons: IGeneralButton[] = props.parameters.cancelBttn ? [
		props.parameters.okBttn,
		props.parameters.cancelBttn
	] : [
		props.parameters.okBttn
	];

	const btnStyle = { margin: '0 1.5%', minWidth: props.parameters.cancelBttn ? '47.5%' : '100%' };
	const generalButtons = (modalButtons).map(({ text, onClick }) => {
		return (
			<GeneralButton key={text} text={text} onClick={onClick} style={btnStyle} />
		);
	});

	const handleKey = useCallback((e: any) => {
		if (e.keyCode === 9) {//focus trap to prevent tabbing throught the element behind the popup
			let focusableParent = document.querySelector('.pause-modal-background');
			if(!focusableParent) return;
			let focusable = Array.prototype.slice.call(focusableParent.querySelectorAll('.modal-container-title p'))
			.concat(Array.prototype.slice.call(focusableParent.querySelectorAll('.general-btn-background')));

			updateElementFocus(e, focusable);
		}
	}, []);

	return (
		<div className="ui-inner-container modal-disable-select">
			<MenuModal
				title={props.parameters.text}
				isActive={true}
				handleKey={handleKey}
				titleContainerStyle={{
					paddingTop: '10px'
				}}>
				{generalButtons}
			</MenuModal>
		</div>);
};

export default PauseMenu;